module.exports = __webpack_public_path__ + "static/media/infotip.3467a569.png";